import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { Link, useRouteMatch } from 'react-router-dom'
import Flex, { FlexItem } from 'styled-flex-component'

import { LogoLink } from '@components/UI/TitleBar'
import TitleBarStyled, {
  HeaderBackButton,
  HeaderTitle,
} from '@components/UI/TitleBar/TitleBar.styled'
import { PageRoutes } from '@enums'
import { IApplicationState } from '@store'
import { selectBrandFanGroupName } from '@store/brandFans'
import Theme from '@theme'
import { Container, H5 } from '@tribegroup'
import { TitleBarContent } from './TitleBar.styled'

const BrandFansGroupDetailsTitleBar: React.FC = () => {
  const match = useRouteMatch<{ brandFansGroupId: string }>()
  const groupId = (
    match.params.brandFansGroupId ? parseInt(match.params.brandFansGroupId, 10) : undefined
  ) as number
  const groupName = useSelector((state: IApplicationState) =>
    selectBrandFanGroupName(state, groupId),
  )
  return (
    <TitleBarStyled>
      <Flex alignCenter full>
        <Container absolute>
          <LogoLink />
        </Container>
        <TitleBarContent>
          <Flex alignCenter full>
            <FlexItem noShrink>
              <Link to={`/${PageRoutes.BrandFanGroups}`}>
                <HeaderBackButton glyph="nav-back-default" size={1.5} color={Theme.grey900Color} />
              </Link>
            </FlexItem>
            <HeaderTitle>
              <H5 color={Theme.grey900Color}>
                <FormattedMessage id="brandFans.groups.titlebar" values={{ groupName }} />
              </H5>
            </HeaderTitle>
          </Flex>
        </TitleBarContent>
      </Flex>
    </TitleBarStyled>
  )
}

export { BrandFansGroupDetailsTitleBar }
export default BrandFansGroupDetailsTitleBar
